<template>
  <div>
    <el-upload
      class="file-uploader"
      action
      :accept="`.json`"
      :show-file-list="false"
      :http-request="uploadFiles"
    >
      <el-button
        size="medium"
        type="primary"
        icon="el-icon-upload2"
        :loading="callingAPI"
        :disabled="disabled"
      >
        <span v-if="showText">Import</span>
      </el-button>
    </el-upload>
    <ImportExcelPopup
      v-if="visible"
      :title="title"
      :visible="visible"
      :total="total"
      :columns="columns"
      :object-type="objectType"
      :type="type"
      :excel-data="excelData"
      :templates="templates"
      @close="visible = false"
      @reload="() => $emit('reload')"
    />
  </div>
</template>

<script>
import ImportExcelPopup from "../popups/ImportExcel.vue";

export default {
  name: "ImportExcelButton",
  components: {
    ImportExcelPopup,
  },
  props: {
    title: String,
    total: Number,
    disabled: Boolean,
    columns: Array,
    type: String,
    objectType: String,
    templates: Array,
    showText: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      callingAPI: false,
      excelData: [],
    };
  },
  computed: {},
  methods: {
    async uploadFiles(fileInfo) {
      const file = fileInfo.file;
      this.callingAPI = true;
      const reader = new FileReader();
      const self = this;
      reader.onload = function (e) {
        const data = e.target.result;
        self.excelData = JSON.parse(data);
        self.visible = true;
        self.callingAPI = false;
      };

      reader.onerror = function (ex) {
        console.log(ex);
      };

      reader.readAsText(file);
    },
  },
};
</script>

<style lang="scss" scoped></style>
